!(function () {
  function t(t, e) {
    return (e || document).querySelector(t);
  }
  function e(t, e) {
    return Array.prototype.slice.call((e || document).querySelectorAll(t));
  }
  function n(t) {
    var e = String(t);
    return window.CSS && "function" == typeof window.CSS.escape
      ? window.CSS.escape(e)
      : e.replace(/[^\w-]/g, function (t) {
          return "\\" + t;
        });
  }
  function i() {
    var i = t("#AddToCartForm");
    if (i) {
      var a = t("#productSelect", i);
      if (a) {
        (document.addEventListener("click", function (n) {
          var i = n.target.closest(".nm-chip");
          if (i) {
            i.classList.contains("is-disabled") &&
              i.classList.remove("is-disabled");
            var o = i.closest("[data-nm-option-index]");
            if (o) {
              (n.preventDefault(),
                e(".nm-chip", o).forEach(function (t) {
                  t.classList.remove("is-active");
                }),
                i.classList.add("is-active"));
              var c = parseInt(o.getAttribute("data-nm-option-index"), 10),
                s = i.getAttribute("data-value"),
                u = t("#productSelect-option-" + c);
              if (u)
                for (var l = 0; l < u.options.length; l++)
                  if (u.options[l].value === s) {
                    ((u.selectedIndex = l),
                      u.dispatchEvent(new Event("change", { bubbles: !0 })));
                    break;
                  }
              var v = (function () {
                for (var n = [], i = 0; ;) {
                  var a = t("#productSelect-option-" + i);
                  if (!a) break;
                  (n.push(a.value), i++);
                }
                return (
                  n.length ||
                    e("[data-nm-option-index]").forEach(function (e, i) {
                      var a = t(".nm-chip.is-active", e);
                      n[i] = a ? a.getAttribute("data-value") : "";
                    }),
                  n
                );
              })();
              ((v[c] = s),
                (function (e) {
                  if (e) {
                    for (var n = 0; n < a.options.length; n++)
                      if (String(a.options[n].value) === String(e.id)) {
                        ((a.selectedIndex = n),
                          a.dispatchEvent(
                            new Event("change", { bubbles: !0 }),
                          ));
                        break;
                      }
                    var i = t("#ProductPrice");
                    if (i && void 0 !== e.price) {
                      var o = e.price / 100;
                      i.textContent =
                        "$ " +
                        o.toLocaleString("es-MX", { minimumFractionDigits: 2 });
                    }
                    var c = t("#AddToCart"),
                      d = t("#AddToCartText");
                    if (
                      (c &&
                        ((c.disabled = !e.available),
                        d &&
                          (d.textContent = e.available
                            ? "Agregar al carrito"
                            : "Agotado")),
                      e.featured_image && e.featured_image.src)
                    ) {
                      var s = t("#ProductPhotoImg") || t("#nmMainProductImg");
                      s &&
                        ((s.style.opacity = "0.6"),
                        "function" ==
                        typeof window.nmSetResponsiveProductImage
                          ? window.nmSetResponsiveProductImage(
                              s,
                              e.featured_image.src,
                            )
                          : (s.setAttribute("src", e.featured_image.src),
                            s.removeAttribute("srcset")),
                        (s.onload = function () {
                          s.style.opacity = "1";
                        }),
                        setTimeout(function () {
                          s.style.opacity = "1";
                        }, 500));
                    }
                    r();
                  }
                })(d(v)));
            }
          }
        }),
          document.addEventListener("change", function (i) {
            var a = i.target;
            if (a && a.id && 0 === a.id.indexOf("productSelect-option-")) {
              var o = t(
                '[data-nm-option-index="' +
                  parseInt(a.id.split("productSelect-option-")[1], 10) +
                  '"]',
              );
              if (o) {
                e(".nm-chip", o).forEach(function (t) {
                  t.classList.remove("is-active");
                });
                var c = t('.nm-chip[data-value="' + n(a.value) + '"]', o);
                (c && c.classList.add("is-active"), r());
              }
            }
          }));
        var o = 0,
          c = setInterval(function () {
            (t("#productSelect-option-0") || ++o > 30) &&
              (clearInterval(c),
              e("[data-nm-option-index]").forEach(function (i) {
                var a = t(
                  "#productSelect-option-" +
                    i.getAttribute("data-nm-option-index"),
                );
                if (a) {
                  e(".nm-chip", i).forEach(function (t) {
                    t.classList.remove("is-active");
                  });
                  var r = t('.nm-chip[data-value="' + n(a.value) + '"]', i);
                  r && r.classList.add("is-active");
                }
              }),
              r());
          }, 100);
      }
    }
    function d(t) {
      var e =
        window.__nmVariants && window.__nmVariants.length
          ? window.__nmVariants
          : window.__nmProduct && window.__nmProduct.variants
            ? ((window.__nmVariants = window.__nmProduct.variants),
              window.__nmVariants)
            : null;
      return (
        (e &&
          e.filter(function (e) {
            return t.every(function (t, n) {
              return e["option" + (n + 1)] === t;
            });
          })[0]) ||
        null
      );
    }
  }
  function a() {
    var e = t("#ProductPhotoImg") || t("#nmMainProductImg");
    if (e) {
      var n = document.createElement("div");
      ((n.className = "nm-product-lightbox"),
        (n.innerHTML =
          '<button type="button" class="nm-product-lightbox__close" aria-label="Cerrar">×</button><img alt="Imagen de producto ampliada"><div class="nm-product-lightbox__hint">Click para cerrar</div>'),
        document.body.appendChild(n));
      var i = t("img", n);
      (e.addEventListener("click", function (t) {
        var a;
        (t.preventDefault(),
          (a =
            e.getAttribute("data-zoom") ||
            e.getAttribute("src") ||
            e.currentSrc) &&
            ((i.src = a),
            n.classList.add("is-open"),
            (document.documentElement.style.overflow = "hidden")));
      }),
        n.addEventListener("click", a),
        document.addEventListener("keydown", function (t) {
          "Escape" === t.key && a();
        }));
    }
    function a() {
      (n.classList.remove("is-open"),
        (document.documentElement.style.overflow = ""));
    }
  }
  function r() {
    var e = t("#nmStickyATC");
    if (e) {
      var n = t("[data-nm-sticky-title]", e),
        i = t("[data-nm-sticky-price]", e),
        a = t("#nmStickyAdd", e),
        r = t('h1[itemprop="name"]') || t(".nm-pdp-hero-copy__title");
      n && r && (n.textContent = r.textContent.trim());
      var o = t("#ProductPrice");
      if ((i && o && (i.textContent = o.textContent.trim()), a)) {
        var c = t("#AddToCart");
        a.disabled = !!c && c.disabled;
      }
    }
  }
  function o() {
    (!(function () {
      var n = t("#ProductPhotoImg") || t("#nmMainProductImg");
      if (n) {
        var i =
          t("#ProductThumbs") ||
          t(".nm-pdp__thumbs") ||
          t(".product-single__thumbnails");
        i &&
          i.addEventListener("click", function (t) {
            var a = t.target.closest(
              ".nm-pdp__thumb, .product-single__thumbnail, a[data-full]",
            );
            if (a) {
              (t.preventDefault(),
                t.stopPropagation(),
                e(".nm-pdp__thumb, .product-single__thumbnail", i).forEach(
                  function (t) {
                    t.classList.remove("is-active");
                  },
                ),
                a.classList.add("is-active"));
              var r = a.getAttribute("data-full") || a.getAttribute("href");
              r &&
                ((n.style.opacity = "0.6"),
                "function" == typeof window.nmSetResponsiveProductImage
                  ? window.nmSetResponsiveProductImage(n, r)
                  : (n.setAttribute("src", r),
                    n.setAttribute("data-zoom", r),
                    n.removeAttribute("srcset")),
                (n.onload = function () {
                  n.style.opacity = "1";
                }),
                setTimeout(function () {
                  n.style.opacity = "1";
                }, 500));
            }
          });
      }
    })(),
      a(),
      (function () {
        var e = t("#nmQty");
        if (e) {
          var n = t('input[name="quantity"]', e);
          if (n) {
            var i = t('[data-q="-"]', e),
              a = t('[data-q="+"]', e);
            (i &&
              i.addEventListener("click", function (t) {
                (t.preventDefault(),
                  (n.value = r(parseInt(n.value, 10) - 1)),
                  n.dispatchEvent(new Event("change", { bubbles: !0 })));
              }),
              a &&
                a.addEventListener("click", function (t) {
                  (t.preventDefault(),
                    (n.value = r(parseInt(n.value, 10) + 1)),
                    n.dispatchEvent(new Event("change", { bubbles: !0 })));
                }));
          }
        }
        function r(t) {
          return (
            (t = parseInt(t || "1", 10)),
            isNaN(t) || t < 1 ? 1 : t > 99 ? 99 : t
          );
        }
      })(),
      i(),
      (function () {
        var e = t("#nmStickyATC");
        if (e) {
          var n = t("#nmATCSentinel");
          n &&
            new IntersectionObserver(
              function (n) {
                n.forEach(function (n) {
                  var i = !n.isIntersecting;
                  e.style.display = i ? "flex" : "none";
                  e.classList.toggle("is-visible", i);
                  document.documentElement.classList.toggle(
                    "nm-sticky-atc-active",
                    i,
                  );
                  if (i) {
                    var r = Math.ceil(e.getBoundingClientRect().height);
                    r &&
                      document.documentElement.style.setProperty(
                        "--nm-sticky-atc-height",
                        r + "px",
                      );
                  }
                  window.dispatchEvent(
                    new CustomEvent("nm:sticky-atc-change", {
                      detail: { visible: i },
                    }),
                  );
                  var a = t("#nmChatFab") || t(".nm-chat-fab");
                  a && a.classList.toggle("nm-pushed-up", i);
                });
              },
              { threshold: 0 },
            ).observe(n);
          var i = t("#nmStickyAdd", e);
          i &&
            i.addEventListener("click", function () {
              var e = t("#AddToCart");
              e && e.click();
            });
        }
      })(),
      r());
    var n = t("#ProductPrice");
    n &&
      new MutationObserver(r).observe(n, {
        subtree: !0,
        childList: !0,
        characterData: !0,
      });
  }
  window.__nmPdpEnhancedInit ||
    ((window.__nmPdpEnhancedInit = !0),
    "loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", o)
      : o());
})();
